import { $t } from "@/lib/i18nHelpers";
import { FormFields } from "@/types";

export const focusNext = (value: string, el: HTMLInputElement) => {
  let form = el.form;
  if (!form) return;
  const index = Array.from(form.elements).findIndex(item => item === el);
  if (index === -1) return;
  let next = form.elements.item(index + 1);
  if (next) (next as HTMLInputElement).focus();
};

export const translateLabelsInFields = (fields: FormFields): FormFields => {
  return fields.map(i => ({ ...i, label: i.label && $t(i.label) }));
};
